export const transactionRoute = [
  {
    path: "deposits",
    name: "deposits",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.transactionOrder.deposits"
    },
    component: () =>
      import(
        /* webpackChunkName: "deposits" */ "@/components/TransactionsPage/DepositTable/index"
      )
  },
  {
    path: "withdrawals",
    name: "withdrawals",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.transactionOrder.withdrawals"
    },
    component: () =>
      import(
        /* webpackChunkName: "withdrawals" */ "@/components/TransactionsPage/WithdrawalTable/index"
      )
  },
  {
    path: "exchanges",
    name: "exchanges",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.transactionOrder.exchanges"
    },
    component: () =>
      import(
        /* webpackChunkName: "exchanges" */ "@/components/TransactionsPage/ExchangeTable/index"
      )
  },
  {
    path: "transfers",
    name: "transfers",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.transactionOrder.transfers"
    },
    component: () =>
      import(
        /* webpackChunkName: "exchanges" */ "@/components/TransactionsPage/TransferTable/index"
      )
  }
];
